import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { TableProrrogasDataSource, TableProrrogasItem } from './table-prorrogas-datasource';

@Component({
  selector: 'app-table-prorrogas',
  templateUrl: './table-prorrogas.component.html',
  styleUrls: ['./table-prorrogas.component.scss']
})
export class TableProrrogasComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<TableProrrogasItem>;
  dataSource: TableProrrogasDataSource;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['fecha_inicio', 'fecha_fin'];

  ngOnInit() {
    this.dataSource = new TableProrrogasDataSource();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }

  ejecutarFuncion(funcion = '') {
    alert('Thanks');
  }
}
